/* eslint key-spacing: 'off', comma-spacing: 'off' */

export default {
    getVariables: function () {
        return [
            ['<nextLocation>', 'Click "Next" to choose one or more locations'],
            ['<crosstabLink>', 'For more information click here...']
        ]
    },
    getText: function (state) {
        switch (state.step) {
            case 'years':
                if (!state.justSelectedYear)
                    return [
                        'Start building your cross tabulation table by selecting one or more years.',
                        'You may choose to analyze a <b>Single Year</b> of data, <b>Combine</b> two or more years of data, or <b>Compare</b> data across two or more years.',
                        'Start the cross tabulation analysis over at any time by clicking the "Reset" button to the left.',
                        '<crosstabLink>',
                        'YR010'
                    ]
                if (state.singleYearSelected)
                    return [
                        'You have chosen to analyze a single year of data. ', 'Click "Next" to choose one or more locations.',
                        'YR020'
                    ]
                if (state.combiningYears)
                    return [
                        'You have chosen to combine multiple years of data for your analysis. ',
                        'Click "Next" to choose one or more locations.',
                        'YR030'
                    ]
                if (state.comparingYears)
                    return [
                        'You have chosen to compare across multiple years of data. ',
                        'Because you have chosen to <b> Compare Years</b>, you must choose <b>"Year"</b> as a row variable, column variable, or control variable in the following steps.',
                        'Click "Next" to choose one or more locations.',
                        'YR040'
                    ]
                break;
            case 'location':
                if (!state.justSelectedLocation)
                    return [
                        'Select one or more locations. ',
                        'You may choose to analyze a <b> Single Location</b> of data, to <b> Combine</b> data from two or more states, or to <b> Compare</b> data across two or more states. ',
                        'LOC010'
                    ]
                if (state.singleLocationSelected)
                    return [
                        'You have chosen to analyze data from a single location. ',
                        'Click "Next" to choose a row variable or click "Back" to change your year selection.',
                        'LOC020'
                    ]
                if (state.combiningLocations)
                    return [
                        'You have chosen to combine data from multiple states. ',
                        'Click "Next" to choose a row variable or click "Back" to change your year selection.',
                        'LOC030'
                    ]
                if (state.comparingLocations)
                    return [
                        'You have chosen to compare data across multiple states. ',
                        'Because you have chosen to <b>Compare States</b>, you must choose <b>"Location"</b> as a row variable, column variable, or control variable in the following steps.',
                        'Click "Next" to choose a row variable or click "Back" to change your year selection.',
                        'LOC040'
                    ]
                break;
            case 'rowvariable':
                if (!state.isRowSelected && state.comparingYears && state.comparingLocations)
                    return [
                        'Select your first variable for analysis. Since you are comparing across years and locations, you may select year, location, or a topic',
                        'The levels of the variable you select will be displayed as rows in the output cross tabulation.',
                        getVariableSelectCaveat(state),
                        'Click "Next" after making your selection or click "Back" to change your location selection.',
                        'ROW010'
                    ]
                if (!state.isRowSelected && state.comparingYears)
                    return [
                        'Select your first variable for analysis. Since you are comparing across years, you may select year or a topic.',
                        'The levels of the variable you select will be displayed as rows in the output cross tabulation.',
                        getVariableSelectCaveat(state),
                        'Click "Next" after making your selection or click "Back" to change your location selection.',
                        'ROW020'
                    ]
                if (!state.isRowSelected && state.comparingLocations)
                    return [
                        'Select your first variable for analysis. Since you are comparing across locations, you may select location or a topic.',
                        'The levels of the variable you select will be displayed as rows in the output cross tabulation.',
                        getVariableSelectCaveat(state),
                        'Click "Next" after making your selection or click "Back" to change your location selection.',
                        'ROW030'
                    ]
                if (!state.isRowSelected)
                    return [
                        'Select your first variable for analysis. The levels of the variable you select will be displayed as rows in the output cross tabulation.',
                        'Click "Next" after making your selection or click "Back" to change your location selection.',
                        'ROW040'
                    ]
                if (state.rowIsYear)
                    return [
                        'You have selected your row variable to be year. This means that each year will be displayed as a separate row in the output cross tabulation.',
                        'Click "Next" to select your column variable or click "Back" to change your location selection.',
                        'ROW050'
                    ]
                if (state.rowIsLocation)
                    return [
                        'You have selected your row variable to be location. This means that each state will be displayed as a separate row in the output cross tabulation.',
                        'Click "Next" to select your column variable or click "Back" to change your location selection.',
                        'ROW060'
                    ]
                return [
                    'You have selected a variable for the row. This means that each level of this variable will be displayed as a separate row in the output cross tabulation.',
                    'Click "Next" to select your column variable or click "Back" to change your location selection.',
                    'ROW070'
                ]
            case 'columnvariable':
                if (!state.isColumnSelected && state.comparingYears && state.comparingLocations && !state.hasYearBeenAssigned && !state.hasLocationBeenAssigned)
                    return [
                        'Select one topic as your column variable. Since you are comparing years and locations, you may select year, location, or a topic. ',
                        'The levels of the variable you select will be displayed as columns in the output cross tabulation.',
                        getVariableSelectCaveat(state),
                        'Click "Next" after making your selection or click "Back" to change your row variable selection.',
                        'COL010'
                    ]
                if (!state.isColumnSelected && state.comparingYears && state.comparingLocations && !state.hasYearBeenAssigned && state.hasLocationBeenAssigned)
                    return [
                        'Select one topic as your column variable. Because you have selected to compare across years, you may select year or a topic.',
                        'The levels of the variable you select will be displayed as columns in the output cross tabulation.',
                        getVariableSelectCaveat(state),
                        'Click "Next" after making your selection or click "Back" to change your row variable selection.',
                        'COL020'
                    ]
                if (!state.isColumnSelected && state.comparingYears && state.comparingLocations && state.hasYearBeenAssigned && !state.hasLocationBeenAssigned)
                    return [
                        'Select one topic as your column variable. Because you have selected to compare across locations, you may select location or a topic.',
                        'The levels of the variable you select will be displayed as columns in the output cross tabulation.',
                        getVariableSelectCaveat(state),
                        'Click "Next" after making your selection or click "Back" to change your row variable selection.',
                        'COL030'
                    ]
                if (!state.isColumnSelected && state.comparingYears && !state.hasYearBeenAssigned)
                    return [
                        'Select one topic as your column variable. Since you are comparing across years, you may select year of a topic.',
                        'The levels of the variable you select will be displayed as columns in the output cross tabulation.',
                        getVariableSelectCaveat(state),
                        'Click "Next" after making your selection or click "Back" to change your row variable selection.',
                        'COL040'
                    ]
                if (!state.isColumnSelected && state.comparingYears && state.hasYearBeenAssigned)
                    return [
                        'Optional: Select one topic as your column variable. The levels of the variable you select will be displayed as columns in the output cross tabulation.',
                        getVariableSelectCaveat(state),
                        'Click "Next" after making your selection or click "Back" to change your row variable selection.',
                        'COL050'
                    ]
                if (!state.isColumnSelected && state.comparingLocations && !state.hasLocationBeenAssigned)
                    return [
                        'Select one topic as your column variable. Because you have selected to compare across locations, you may select location or a topic.',
                        'The levels of the variable you select will be displayed as columns in the output cross tabulation.',
                        'Since you are comparing locations, you may select location or a topic.',
                        getVariableSelectCaveat(state),
                        'Click "Next" after making your selection or click "Back" to change your row variable selection.',
                        'COL060'
                    ]
                if (!state.isColumnSelected && state.comparingLocations && state.hasLocationBeenAssigned)
                    return [
                        'Optional: Select one topic as your column variable. The levels of the variable you select will be displayed as rows in the output cross tabulation.',
                        getVariableSelectCaveat(state),
                        'Click "Next" after making your selection or click "Back" to change your row variable selection.',
                        'COL070'
                    ]
                if (!state.isColumnSelected)
                    return [
                        ' Optional: Select one topic as your column variable. The levels of the variable you select will be displayed as columns in the output cross tabulation.',
                        'Click "Next" after making your selection or click "Back" to change your row variable selection.',
                        'COL075'
                    ]
                if (state.isColumnSelected && state.columnIsYear)
                    return [
                        'You have selected your column variable to be year. This means that each year will be displayed as a separate column in the output cross tabulation.',
                        'Click "Next" to select optional control variables or click "Back" to change your row variable selection',
                        'COL080'
                    ]
                if (state.isColumnSelected && state.columnIsLocation)
                    return [
                        'You have selected your column variable to be location. This means that each state will be displayed as a separate column in the output cross tabulation.',
                        'Click "Next" to select your optional control variables or click "Back" to change your row variable selection.',
                        'COL090'
                    ]
                if (state.isColumnSelected)
                    return [
                        'You have selected a variable for the column. Each level of your selected variable will be displayed as a separate column in the output cross tabulation.',
                        'Click "Next" to select your optional control variables or click "Back" to change your row variable selection.',
                        'COL100'
                    ]
                return [
                    'COL110'
                ]
            case 'controlvariables':
                if (!state.isControl1Selected && state.comparingYears && state.comparingLocations && state.hasYearBeenAssigned && state.hasLocationBeenAssigned)
                    return [
                        'You selected to compare years and locations to in your cross tabulation. Year and location have been selected as row and column variables. Therefore, you have the option of selecting <u>up to</u> two control variables or selecting none at all.',
                        'One cross tabulation table will be displayed for each level of each control variable selected.',
                        getVariableSelectCaveat(state),
                        'After making your selection, click "Next" to select included statistics or click "Back" to change your column variable selection.',
                        'CNT010'
                    ]
                if (!state.isControl1Selected && state.comparingYears && state.comparingLocations && !state.hasYearBeenAssigned && !state.hasLocationBeenAssigned)
                    return [
                        'You selected to compare multiple years and multiple locations in your cross tabulation. These variables have not been selected as row or column variables. Therefore, you must select <b>"Year"</b> and <b>"Location"</b> as your control variables',
                        'One cross tabulation table will be displayed for each year and location.',
                        'After making your selection, click "Next" to select included statistics or click "Back" to change your column variable selection.',
                        'CNT020'
                    ]
                if (!state.isControl1Selected && state.comparingYears && !state.hasYearBeenAssigned)
                    return [
                        'You selected to compare multiple years in your cross tabulation. "Year" has not been selected as a row or column variable. Therefore, you must select <b>"Year"</b> as a control variable.',
                        'You have the option of selecting one additional control variable from the list.',
                        'One cross tabulation table will be displayed for each level of each control variable selected.',
                        'After making your selection, click "Next" to select included statistics or click "Back" to change your column variable selection.',
                        'CNT030'
                    ]
                if (state.isControl1Selected && state.comparingYears && state.control2IsYear)
                    return [
                        'You selected to compare multiple years in your cross tabulation. "Year" has not been selected as a row, column, or control variable. Therefore, <b>"Year"</b> has been selected an additional control variable.',
                        'One cross tabulation table will be displayed for each year and each level of the control variable selected.',
                        'Click "Next" to select included statistics or click "Back" to change your column variable selection.',
                        'CNT040'
                    ]
                if (!state.isControl1Selected && state.comparingLocations && !state.hasLocationBeenAssigned)
                    return [
                        'You selected to compare multiple states in your cross tabulation. "Location" has not been selected as a row or column variable. Therefore, you must select <b>"Location"</b> as a control variable.',
                        'You have the option of selecting one additional control variable from the list.',
                        'One cross tabulation table will be displayed for each level of each control variable selected.',
                        'After making your selection, click "Next" to select included statistics or click "Back" to change your column variable selection.',
                        'CNT050'
                    ]
                if (state.isControl1Selected && state.comparingLocations && state.control2IsLocation)
                    return [
                        'You selected to compare multiple states in your cross tabulation. "Location" has not been selected as a row, column, or control variable. Therefore, <b>"Location"</b> has been selected an additional control variable.',
                        'One cross tabulation table will be displayed for each state and each level of the control variable selected.',
                        'Click "Next" to select included statistics or click "Back" to change your column variable selection.',
                        'CNT060'
                    ]
                if (!state.isControl1Selected && state.comparingLocations && state.hasLocationBeenAssigned)
                    return ['You selected to compare multiple states in your cross tabulation. "Location" has been selected as a row or column variable. Therefore, you have the option of selecting <u>up to</u> two control variables or selecting none at all.',
                        'If you choose to include a control variable, one cross tabulation table will be displayed for each level of each control variable selected.',
                        'Click "Next" to select included statistics or click "Back" to change your column variable selection.',
                        'CNT063'
                    ]
                if (!state.isControl1Selected && state.comparingYears && state.hasYearBeenAssigned)
                    return [
                        'You selected to compare multiple years in your cross tabulation. "Year" has been selected as a row or column variable. Therefore, you have the option of selecting <u>up to</u> two control variables or selecting none at all.',
                        'If you choose to include a control variable, one cross tabulation table will be displayed for each level of each control variable selected.',
                        getVariableSelectCaveat(state),
                        'Click "Next" to select included statistics or click "Back" to change your column variable selection.',
                        'CNT066'
                    ]
                if (!state.isControl1Selected)
                    return [
                        'You selected one year and one location to analyze in your cross tabulation. Therefore, you have the option of selecting <u>up to</u> two control variables or selecting none at all.',
                        'If you choose to include a control variable, one cross tabulation table will be displayed for each level of each control variable selected.',
                        getVariableSelectCaveat(state),
                        'After making your selection, click "Next" to select included statistics or click "Back" to change your column variable selection.',
                        'CNT070'
                    ]
                if (state.isControl1Selected && !state.isControl2Selected)
                    return [
                        'You selected to include one control variable in your cross tabulation. Therefore, you have the <b>option</b> of selecting a second control variable.',
                        'One cross tabulation table will be displayed for each level of each control variable selected.',
                        getVariableSelectCaveat(state),
                        'After making your selection, click "Next" to select included statistics or click "Back" to change your column variable selection.',
                        'CNT080'
                    ]
                if (state.isControl1Selected && state.isControl2Selected)
                    return [
                        'You have selected to include two control variables. One cross tabulation table will be displayed for each level of each control variable selected.',
                        'Click "Next" to select included statistics or click "Back" to change your column variable selection',
                        'CNT090'
                    ]
                return [];
            //case 'controlvariables':
            case 'statistics':
                if (state.singleYearSelected)
                    return [
                        'Certain calculated statistics have already been selected for you. These statistics are standard when running a cross tabulation.',
                        '"Check" the <b>Standard Error</b> and/or <b>95% Confidence Interval</b> boxes under the "Select Additional Statistics" section if you would like to see additional row and column statistics in your analysis.',
                        '"Check" <b>Include Weighted N</b> to produce estimated population totals. "Check" <b>Include Non Response Categories</b> to include "Don\'t Know" and "Refused" as categories in your analysis.',
                        'After making your selections, click <b>"Run Report"</b> to view the results of the cross tabulation. Click "Back" to change your control variable selection(s).',
                        'STA010'
                    ]
                if (!state.singleYearSelected)
                    return [
                        'Certain calculated statistics have already been selected for you. These statistics are standard when running a cross tabulation.',
                        '"Check" the <b>Standard Error</b> and/or <b>95% Confidence Interval</b> boxes under the "Select Additional Statistics" section if you would like to see additional row and column statistics in your analysis.',
                        '"Check" <b>Include Non Response Categories</b> to include "Don\'t Know" and "Refused" as categories in your analysis. <b>Include Weighted N</b> is not available because you have selected multiple years, and Weighted N can be misleading.',
                        'After making your selections, click <b>"Run Report"</b> to view the results of the cross tabulation. Click "Back" to change your control variable selection(s).',
                        'STA020'
                    ]
                return [];
            case 'viewreport':
                return [
                    'The results of your cross tabulation analysis are below.',
                    'To reset your selections, click the "Reset" button to the left.',
                    'To modify the statistical output on this results page, click "Modify" to make different selections on the previous screen.',
                    'Download and save the results of your cross tabulation to Excel by clicking the "Download Results" link to the left."',
                    'REP010'
                ]
        }
        return [];
    }

}

function getVariableSelectCaveat(state) {
    const suffix = state.combiningYears || state.comparingYears ? 's' : '';
    return 'The variables listed are only the variables for the year' + suffix + ' selected';
}
